import {combineReducers} from 'redux';
import root from './root';
import progress from './progress';
import steps from './steps';
import questions from './questions';
import inputs from './inputs';
import context from './context';
import services from './services';
import reviewMetrics from './review-metrics';

const appReducer = combineReducers({
  context,
  progress,
  entities: combineReducers({
    steps,
    questions,
    inputs,
    services,
  }),
  valueObjects: combineReducers({
    reviewMetrics,
  }),
});

export default root(appReducer);
